import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import contextTypes from 'bundles/email/context_types';
import { mapId, mapName } from 'helpers/react_select_helpers';

class PropertySelect extends React.Component {
  static propTypes = {
    allProperties: PropTypes.array.isRequired,
    design: PropTypes.object.isRequired,
    properties: PropTypes.array.isRequired,
    property: PropTypes.object.isRequired,
    onPropertiesChange: PropTypes.func.isRequired,
    onPropertyChange: PropTypes.func.isRequired,
  }

  handleChange = (selection) => {
    if (this.props.design.contextType === contextTypes.multiPropertyEmail) {
      this.props.onPropertiesChange(selection);
    } else {
      this.props.onPropertyChange(selection);
    }
  }

  render() {
    if (this.props.design.contextType === contextTypes.spaceNeedsEmail) {
      return null;
    }

    const multiProperty = this.props.design.contextType === contextTypes.multiPropertyEmail;
    const label = multiProperty ? 'Properties' : 'Property';
    const value = multiProperty ? this.props.properties : this.props.property;

    return (
      <div>
        <p className="fs-large mb-1">Preview {label}:</p>
        <Select
          getOptionLabel={mapName}
          getOptionValue={mapId}
          isMulti={multiProperty}
          menuPosition="fixed"
          options={this.props.allProperties}
          value={value}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default PropertySelect;
